import React from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import DownloadSettlementForm from "../../../components/widgets/forms/setup/DownloadSettlementForm";

const DownloadSettlement = ({ show, onHide, underwriterId }) => {
  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey text-center">Download Settlement</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DownloadSettlementForm underwriterId={underwriterId} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DownloadSettlement;